import './TransactionStatistics.scss'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useSelector } from 'react-redux';
import FilterThiTruong from '../../../common/FilterThiTruong';
import LabelFooter from 'components/common/Chart/LabelFooter';
import { options } from './TransactionStatisticsConfig';
import useMarket from 'hook/useMarket';
import API from 'service/API';
import { useEffect, useState } from 'react';
import useHelper from 'hook/useHelper';
import EmptyData from 'components/common/EmptyData';

export default function TransactionStatistics() {
  const CommnonStore = useSelector((state: any) => state?.CommnonStore);
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore);
  const MarketStore = useSelector((state: any) => state?.MarketStore);
  const [filter, setFilter] = useState({ stock: '', time: 'day' })
  const [FilterLabel, setFilterLabel] = useState<any>([])
  const { handleFilterArray } = useHelper();
  const { filterTrading, fetchStockTicker } = useMarket();

  useEffect(() => {
    setFilter({ ...filter, time: 'day' })
  }, [StocksAnalysisStore?.inputSearch])

  const handleChangeFilterLabel = (value: string) => {
    const FilterLabelNew: any = handleFilterArray(value, FilterLabel)
    setFilterLabel([...FilterLabelNew])
  }

  const handleChangeFilter = (value: string) => {
    if (value !== filter.time) {
      fetchStockTicker({ stock: StocksAnalysisStore?.inputSearch, time: value })
      setFilter({ stock: StocksAnalysisStore?.inputSearch, time: value })
    }
  }

  return (
    <>
      <div className='ovvosnzjvi'>
        {
          MarketStore?.stockTicker.length > 0 ?
            <>
              <FilterThiTruong setSelectOption={(value: string) => handleChangeFilter(value)} defaultData={filter?.time} data={[
                { name: 'Ngày', value: 'day' },
                { name: 'Tuần', value: 'week' },
                { name: 'Tháng', value: 'month' },
              ]} />
            </> : null
        }
        <div className='gzdcyziukl'>
          <div className='plcvejcuxx'>
            <div>
              <div style={{ display: MarketStore?.stockTicker.length > 0 ? 'block' : 'none' }}>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={options(filterTrading(MarketStore?.stockTicker), FilterLabel, CommnonStore)}
                />
                <LabelFooter selectData={(value: string) => handleChangeFilterLabel(value)}
                  listDefault={FilterLabel} data={[
                    { name: 'Cá nhân', color: '#2AD03D' },
                    { name: 'Tổ chức trong nước', color: '#B8B8B8' },
                    { name: 'Tổ chức nước ngoài', color: '#F2994A' },
                    { name: 'Giá', color: '#E31E4D' },
                  ]} />
              </div>
              <div style={{ display: MarketStore?.stockTicker.length > 0 ? 'none' : 'block' }}>
                <div className='rppgarfrpd'>
                  <EmptyData />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}